import { render, staticRenderFns } from "./freeze.vue?vue&type=template&id=f46227dc&scoped=true"
import script from "./freeze.vue?vue&type=script&lang=js"
export * from "./freeze.vue?vue&type=script&lang=js"
import style0 from "./freeze.vue?vue&type=style&index=0&id=f46227dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46227dc",
  null
  
)

export default component.exports